import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import ItemCategoryService from "../../../services/ItemCategoryService";
import Breadcrumb from "../../../components/Breadcrumb";
import ListItemCategory from "../Components/ListItemCategory";
import MessageDialog from "../../../components/MessageDialog";

export default function ViewItemCategory() {
  const [categories, setCategories] = useState([]);
  const [selected, setSelected] = useState(null); //  RADIO SINGLE SELECT
  const [searchText, setSearchText] = useState(""); //  SEARCH
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  const [loading, setLoading] = useState(true);
  // const messageTimer = useRef(null);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const navigate = useNavigate();

  useEffect(() => {
    fetchCategories();
  }, [currentPage, searchText]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchText]);


  const fetchCategories = async () => {
    setLoading(true);
    try {
      const res = await ItemCategoryService.getAll(currentPage, itemsPerPage, searchText);

      const data = res?.data || [];
      const total = res?.total || 0;

      setCategories(data);
      setPageCount(Math.ceil(total / itemsPerPage));
    } catch (err) {
      console.error(err);
      showMessage("Error fetching categories.");
    } finally {
      setLoading(false);
    }
  };


  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };


  const handleSelect = (id) => {
    setSelected(id);
  };

  const handlePageClick = (event) => {
    const selectedPage = event.selected + 1;
    setCurrentPage(selectedPage);
  };


  const handleAdd = () => {
    navigate("/cpnl/itemcategory/add");
  };

  const handleModify = () => {
    if (!selected) {
      showMessage("Please select one Item Category to modify.");
      return;
    }
    navigate(`/cpnl/itemcategory/add/${selected}`);
  };

  const handleToggleStatus = async (category) => {
    const newStatus = category.status === "Active" ? "Inactive" : "Active";
    if (
      !window.confirm(
        `Are you sure do you want change Item category status as ${newStatus}?`
      )
    )
      return;

    setLoading(true);
    try {
      await ItemCategoryService.updateStatus(category.id);
      showMessage("Status updated successfully", "success");
      fetchCategories();
    } catch (error) {
      console.error(error);
      showMessage("Error updating status.");
    } finally {
      setLoading(false);
    }
  };

  //  SEARCH FILTER
  // const filteredCategories = categories.filter(
  //   (c) =>
  //     c.itemCategoryName
  //       .toLowerCase()
  //       .includes(searchText.toLowerCase()) ||
  //     c.itemCategoryCode
  //       .toLowerCase()
  //       .includes(searchText.toLowerCase())
  // );

  const filteredCategories = categories;

  return (
    <>
      <Breadcrumb pageTitle="Item Categories" secondTitle="Masters" />

      <div className="row">
        <div className="card py-2 bg-white shadow-sm">

          {/* {message && (
            <div
              className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
                } d-flex justify-content-between align-items-center mb-2 p-2`}
            >
              <span>{message}</span>
              <button
                type="button"
                className="btn-close"
                onClick={closeMessage}
              ></button>
            </div>
          )} */}

          <MessageDialog
            message={message}
            type={msgType}
            setMessage={setMessage}
            setMsgType={setMsgType}
          />


          {/*  SEARCH + BUTTONS */}
          <div className="mb-3 pb-2 border-bottom d-flex align-items-end gap-3">
            <div>
              <input
                type="text"
                className="form-control"
                placeholder="Search Item Category"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>

            <div className="ms-auto d-flex gap-2">
              <button
                className="d-inline-flex btn btn-success"
                onClick={handleAdd}
                disabled={loading}
              >
                <i className="ti ti-plus me-1"></i> Add
              </button>

              <button
                className="d-inline-flex btn btn-warning"
                onClick={handleModify}
                disabled={loading}
              >
                <i className="ti ti-pencil me-1"></i> Modify
              </button>
            </div>
          </div>

          {/*  TABLE */}
          <ListItemCategory
            loading={loading}
            filteredCategories={filteredCategories}
            selected={selected}
            handleSelect={handleSelect}
            handleToggleStatus={handleToggleStatus}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
          />

        </div>
      </div>
    </>
  );
}
